import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  noOfInverter: 0,
  oneLineMethod: "strings/MPPT",
  DCACRatio: 1.2,
  feedMeter: false,
  noOfStringMPPT: 0,
  actualStringMPPT: 0,
  actualString: 0,
  totalStringMPPT: 0,
  lastStringMPPT: 0,
  error: "",
  errorShow: false,
  inverterPhase: "Three Phase",
  systemType: "On Grid",
};

export const inverterInfo = createSlice({
  name: "inverterInfo",
  initialState: initialState,
  reducers: {
    updateInverterInfo: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetInverterInfo: (state, action) => {
      return initialState;
    },
  },
});

export const { updateInverterInfo, resetInverterInfo } = inverterInfo.actions;

export default inverterInfo.reducer;

export const methodSelect = ["MPPT", "strings/MPPT"];
